// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"c8b7c16a","498":"8281cbf8","513":"6665895c"}[chunkId] + ".chunk.js";
};